import { Skeleton as MuiSkeleton } from '@mui/material'
import { SxProps, useTheme } from '@mui/material/styles'

export const ImageSkeleton = ({
  width,
  height,
  className,
  color,
  sx,
}: {
  width?: string | number
  height?: string | number
  className?: string
  color?: string
  sx?: SxProps
}) => {
  const theme = useTheme()
  const defaultBackgroundColor = `var(--image-skeleton-color, ${theme.palette.background.light})`

  return (
    <MuiSkeleton
      className={className}
      animation="wave"
      variant="rounded"
      width={width}
      height={height}
      // Set --image-skeleton-color on a parent sx/style to tune skeleton contrast for that background.
      sx={{ backgroundColor: color ? color : defaultBackgroundColor, ...sx }}
    />
  )
}
